module.exports = __webpack_public_path__ + "static/media/back_btn_black.92260f8d.svg";